import { render, staticRenderFns } from "./huifang.vue?vue&type=template&id=36508e2d&scoped=true&"
import script from "./huifang.vue?vue&type=script&lang=js&"
export * from "./huifang.vue?vue&type=script&lang=js&"
import style0 from "./huifang.vue?vue&type=style&index=0&id=36508e2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36508e2d",
  null
  
)

export default component.exports